<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="assessmentList">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="
                                                p-4
                                                border border-solid
                                                d-theme-border-grey-light
                                                rounded-full
                                                d-theme-dark-bg
                                                cursor-pointer
                                                flex
                                                items-center
                                                justify-between
                                                font-medium
                                              ">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                assessmentList.length - currentPage * itemsPerPage > 0
                ? currentPage * itemsPerPage
                : assessmentList.length
              }}
              of {{ assessmentList.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="AnswerText">{{ $t('AnswerText') }}</vs-th>
        <vs-th sort-key="FullName">{{ $t('trainee') }}</vs-th>
        <vs-th sort-key="Title">{{ $t('CustomerReview') }}</vs-th>
        <vs-th sort-key="QuestionText">{{ $t('CustomerReviewQuestion') }}</vs-th>
        <vs-th>{{ $t('Status') }}</vs-th>
        <!-- <vs-th>{{ $t('Action') }}</vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click="editData(tr)"
            :to="{ name: 'FeedbackAction-add/Edit', params: { ID: tr.ID } }">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.AnswerText }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate" v-if="tr.Trainee != null">
                {{ tr.Trainee.FullName }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate" v-if="tr.CustomerReview != null">
                {{ tr.CustomerReview.Title }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate" v-if="tr.CustomerReviewQuestion != null">
                {{ tr.CustomerReviewQuestion.QuestionText }}
              </p>
            </vs-td>
            <vs-td style="background-color:red;" v-if="tr.TaskStatusID == 4"> </vs-td>
            <vs-td style="background-color:yellow;" v-if="tr.TaskStatusID == 2"> </vs-td>
            <vs-td style="background-color:gray;" v-if="tr.TaskStatusID == 1"> </vs-td>
            <vs-td style="background-color:green;" v-if="tr.TaskStatusID == 3"> </vs-td>
            <vs-td style="background-color:wheat;" v-if="tr.TaskStatusID == null"> </vs-td>


            <!-- <vs-td class="whitespace-no-wrap">
                                    <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                      @click.stop="editData(tr)" />
                                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                                      @click.stop="openConfirm(tr)" />
                                    <feather-icon icon="PrinterIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                                      @click.stop="print(tr)" />
                                  </vs-td> -->
          </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>


<script>
import vSelect from "vue-select";
import moduleAssessmentResult from "@/store/customerReview/assessmentResult/moduleAssessmentResult.js";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      itemsPerPage: 10,
      isMounted: false,
      first: true,
      rowDataForDelete: {},
      assessmentList: [],
    };
  },
  computed: {
    currentPage() {
      debugger;
      if (this.isMounted) {
        // if (!this.first)
        //   this.$store.state.courseList.search.pageNum =
        //     this.$refs.table.currentx;
        // this.first = false;
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },

  methods: {
    editData(model) {
      debugger;
      // if(!this.isDelete)
      this.$router.push({ name: "FeedbackAction-add/Edit", params: { ID: model.ID } });
    },

    // deleteData(data) {
    //   this.$store.dispatch("courseList/removeItem", data).catch((err) => {
    //     console.error(err);
    //   });
    //   this.isDelete = false;
    // },

    // openConfirm(data) {
    //   this.rowDataForDelete = data;
    //   this.$vs.dialog({
    //     type: "confirm",
    //     color: "danger",
    //     title: this.$t("Confirm"),
    //     text: this.$t("Areyousureyouwantdeletethisrecord") + "?",
    //     accept: this.acceptAlert,
    //   });
    // },

    // acceptAlert() {
    //   this.deleteData(this.rowDataForDelete);
    //   this.$vs.notify({
    //     fixed: true,
    //     color: "danger",
    //     title: this.$t("Deletedrecord"),
    //     text: this.$t("Theselectedrecordwassuccessfullydeleted")

    //   });
    // },
  },

  created() {
    if (!moduleAssessmentResult.isRegistered) {
      this.$store.registerModule("AssessmentResultList", moduleAssessmentResult);
      moduleAssessmentResult.isRegistered = true;
    }

    this.$store.dispatch("AssessmentResultList/getAssessmentResultActions").then(res => {
      debugger
      this.assessmentList = res.data;
    })
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style lang="css">
.disabled-upload {
  display: none;
}
</style>
